import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Nav.css';
import SocialIcons from '../../cards/SocialIcons';

export default function Nav() {
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const closeNavbar = () => {
    const toggler = document.querySelector(".navbar-toggler");
    const menu = document.querySelector("#navbarSupportedContent");
    if (toggler && menu.classList.contains("show")) toggler.click();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    setShowSearch(false);
    navigate(`/search/${encodeURIComponent(query)}`);
  };

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 1010 }}>
      <nav className="navbar navbar-expand-lg bg-body-tertiary ps-5">
        <div className="container">

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" >
            <span className="navbar-toggler-icon"></span>
          </button>
  
          <button
            className="search-icon-btn d-lg-none"
            onClick={() => setShowSearch((prev) => !prev)}
          >
            <i className="fas fa-search"></i>
          </button>

          {showSearch && (
            <form
              className="w-100 mt-2 mb-3 d-lg-none"
              onSubmit={handleSearchSubmit}
            >
              <input
                type="search"
                className="form-control"
                placeholder="ابحث في الموقع..."
                dir="rtl"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </form>
          )}

          <div className="collapse navbar-collapse text-end" id="navbarSupportedContent">
            <ul className="navbar-nav w-100 ms-auto mb-2 mb-lg-0 fs-6">

              <li className="nav-item pe-1 d-lg-none my-2 mt-3">
                <SocialIcons />
              </li>

              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" to="/" onClick={closeNavbar}>الرئيسية</NavLink>
              </li>

              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle p-2 p-lg-3 d-flex align-items-center gap-1">
                  الأخبار
                </span>
                <ul
                  className="dropdown-menu text-end"
                  aria-labelledby="newsDropdown"
                  onClick={closeNavbar}
                >
                  <li>
                    <NavLink className="dropdown-item" to="/localNews">أخبار محلية</NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/worldNews">أخبار دولية</NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="report">تقارير</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="articles">مقالات</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="events">الفعاليات</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="research">أبحاث علمية</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="sport">الرياضة</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="technology">تكنولوجيا</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="entertainment">منوعات</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="health">الصحة</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link p-2 p-lg-3" onClick={closeNavbar} to="refugeeIssues">شؤون اللاجئين</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link economy-tab text-center px-3 me-2 mt-2" onClick={closeNavbar} to="economy">اقتصاد</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link live-tab p-2 text-center px-3 me-2 mt-2" onClick={closeNavbar} to="live">مباشر</NavLink>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
